export default "__VITE_ASSET__sUvyxMLO__"